module.exports = __webpack_public_path__ + "img/rinsizeMeasurement@2x.ac41137.webp";